import { useParams } from 'react-router-dom'

import { RouteParams } from '@/routes/routes'

export default function useApSystemId() {
  const { apSystemId } = useParams<RouteParams['AP_SYSTEM']>()
  return apSystemId
}
